import { Component, Inject, OnInit, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'app/core/interfaces/dialog';
import { rescheduleI, scheduleI, scheduleType } from 'app/core/interfaces/schedule';
import { patientI } from 'app/core/interfaces/patient';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import * as moment from 'moment';
import { ScheduleService } from 'app/core/http/services/schedule.service';
import { PractitionerService } from 'app/core/http/services/practitioner.service';

@Component({
  selector: 'page-schedule-registration',
  templateUrl: './schedule-registration.component.html',
  styleUrls: ['./schedule-registration.component.scss'],
})
export class ScheduleRegistrationComponent extends BaseComponent implements OnInit {
  public schedules: scheduleI[] = [];
  public schedule: scheduleI = <scheduleI>{};
  public practitioner: any;
  public procedure: any;
  public patients: patientI[] = [];
  public hours: any[] = [];
  public dates: any[] = [];
  public hour: rescheduleI = <rescheduleI>{};
  public blockedDaysOfWeek = [0, 6];
  public type: scheduleType = 'Consulta';
  public title = '';
  public subtitles = ['Orientações', 'Localização'];
  public organization: any = <any>{};
  public openingHoursText = '';
  public id: number = 0;
  public address: any;
  public practitioners: any[] = [];

  public submittedSchedule = false;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    public scheduleService: ScheduleService,
    private practitionerService: PractitionerService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.type = this.data.param.type;
    if (this.data.param.practitioner) {
      this.practitioner = this.data.param.practitioner;
    }

    if (this.data.param.patient) {
      this.patients = this.data.param.patient;
    }

    if (this.data.param.procedure) {
      this.procedure = this.data.param.procedure;
      this.organization = this.procedure.organization;
      this.getOpeningHours();
    }

    this.address = this.data.param.address;
    if (this.type == 'Consulta') {
      this.id = this.practitioner?.id ? this.practitioner.id : this.practitioner?.practitioner_id;
    } else {
      this.id = this.procedure?.id ? this.procedure.id : this.procedure?.healthcareservice_id;
    }
    this.title = this.type == 'Exame' ? 'Agendar exame ' + this.procedure.name : 'Agendar consulta';
    this.getPractitioners();
  }

  getPractitioners() {
    this.practitionerService.list().subscribe({
      next: (resPractitioner: any) => {
        console.log('Registe', resPractitioner);
        this.practitioners = resPractitioner;
      },
      error: (err) => {
        console.log('Falha ao listar especialista', err);
      },
    });
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    // Only highligh dates inside the month view.
    if (view === 'month') {
      const date = cellDate.getDate();
      // Highlight the 1st and 20th day of each month.
      return date === 1 || date === 20 ? 'warning-date' : '';
    }
    return '';
  };

  saveSchedule() {
    let text = '<div class="col-xs-12 col-md-6></div>"';
    this.layout
      .openDialog({
        showButtonCancel: true,
        buttonText: 'salvar',
        title: '',
        content: 'Deseja criar o atendimento?',
      })
      .subscribe((retorno: any) => {
        if (retorno) {
          this.addSchedule();
          this.dialogRef.close();
        }
      });
  }

  addSchedule() {
    this.schedule = {
      patient: this.currentUser.type == 'patient' ? (this.currentUser.user as patientI) : this.schedule.patient,
      dateStart: moment(this.hour.date).format('YYYY-MM-DD') + ' ' + this.hour.time,
      type: this.type,
      active: true,
      status: 'planned',
      practitioner: this.type == 'Exame' ? this.schedule.practioner : this.practitioner,
    };

    if (this.procedure) {
      this.schedule.procedure = this.procedure;
    }

    if (this.organization) {
      this.schedule.organization = this.organization;
    }

    if (this.patients) {
      this.schedule.patient = this.patients;
    }

    let sheduleFhirResource = this.transformObjectToFHIR(this.schedule);

    this.scheduleService.create(sheduleFhirResource).subscribe({
      next: (res: any) => {
        this.submittedSchedule = false;
        this.showErrorMessage = false;
        this.showSuccessMessage = true;
      },
      error: (error) => {
        this.showErrorMessage = true;
        this.showSuccessMessage = false;
        this.loading = false;
      },
    });
  }

  public transformObjectToFHIR(data: any) {
    let current_date_time = new Date().toISOString();
    const transformedData = {
      resourceType: 'Schedule',
      type: data.type,
      active: data.active,
      status: data.status,
      name: data.type,
      serviceCategory: [
        {
          coding: [
            {
              display: data?.procedure.name,
            },
          ],
        },
      ],
      serviceType: [
        {
          coding: [
            {
              display: data?.procedure.type,
            },
          ],
        },
      ],
      specialty: [
        {
          coding: [
            {
              display: data?.procedure.specialty ? data.procedure.specialty : data?.practioner?.qualification[0]?.identifier[0]?.value || 'Undefined',
            },
          ],
        },
      ],
      actor: [
        {
          reference: 'Practitioner/' + data?.practioner?.practitioner_id ? data.practioner?.practitioner_id : data.practitioner?.practitioner_id,
          code: data?.practioner?.practitioner_id ? data.practioner.practitioner_id : data.practitioner?.practitioner_id,
          display: data?.practioner?.name ? data.practioner.name : data?.practitioner.name,
          type: 'PRACTITIONER',
        },
        {
          reference: 'Organization/' + data?.organization?.organization_id,
          code: data?.organization?.organization_id,
          display: data?.organization?.name,
          type: 'ORGANIZATION',
        },
        {
          reference: 'PATIENT/' + data?.patient?.patient_id,
          code: data?.patient?.patient_id,
          display: data?.patient?.name,
          type: 'PATIENT',
        },
      ],
      planningHorizon: {
        start: data.dateStart,
      },
      requestDateTime: current_date_time,
      updateDateTime: current_date_time,
    };

    return transformedData;
  }

  getSlots(dayOfWeek: number) {
    //@TODO GET free slots
    this.hours = this.getHoursFromOrganization(1, dayOfWeek);
  }

  loadHours(selectedDate: string) {
    const dayOfWeek = moment(selectedDate).weekday();
    //@TODO GET as horas disponíveis no dia selecionado
    this.getSlots(1);
  }

  getPaymentText() {
    let text = '';
    if (this.type == 'Consulta') {
      text = `Valor da consulta <b>R$ ${this.procedure?.price_high}.</b> `;
    }
    if (this.type == 'Exame') {
      text = `Valor da consulta <b>R$ ${this.procedure?.price_high}.</b> `;
    }
    return text;
  }

  hasError(field: string) {
    if ((field == 'patient' && !this.schedule.patient) || (field == 'time' && this.schedule.dateStart == '')) {
      return true;
    }
    return false;
  }

  myFilter = (d: Date | null): boolean => {
    const date = moment(d).format('YYYY-MM-DD');
    const time = moment(d).format('HH:MM');
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
    return this.blockedDaysOfWeek.indexOf(day) === -1;
  };

  getOpeningHours() {
    if (this.organization.schedule) {
      this.openingHoursText = `<b>Atendimento de Segunda a Sexta das ${this.organization.schedule[0].timeStart} ás ${this.organization.schedule[0].timeEnd}.</b>`;
    }
  }

  openPatientForm() {
    this.dialog.openRegisterFormDialog({
      title: 'Cadastrar novo paciente',
      param: { type: 'patient' },
    });
  }
}
